import { render } from "./wechat-linux-bot.vue?vue&type=template&id=31d27bc0&ts=true"
import script from "./wechat-linux-bot.vue?vue&type=script&lang=ts"
export * from "./wechat-linux-bot.vue?vue&type=script&lang=ts"

import "./wechat-linux-bot.vue?vue&type=style&index=0&id=31d27bc0&lang=scss"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__